import { Button, Input } from 'components/atoms';
import { FormInput } from 'components/molecules';
import DataWrapper from 'components/molecules/data-wrapper/DataWrapper';
import ViewHint from 'components/molecules/hint/ViewHint';
import CensoriousSelectPopupForm from 'components/molecules/popup/censorious-select/CensoriousSelectPopupForm';
import CopyrightPopupForm from 'components/molecules/popup/copyright-select/CopyrightSelectPopupForm';
import CreatedWithAiSelectPopupForm from 'components/molecules/popup/created-with-ai-select/CreatedWithAiSelectPopupForm';
import GenrePopupForm from 'components/molecules/popup/genre-select/GenreSelectPopupForm';
import InstrumentalSelectPopupForm from 'components/molecules/popup/instrumental-select/InstrumentalSelectPopupForm';
import LanguageSelectPopupForm from 'components/molecules/popup/language-select/LanguageSelectPopupForm';
import YearSelectPopupForm from 'components/molecules/popup/year-select/YearSelectPopupForm';
import StepsTab from 'components/molecules/steps/tab/StepsTab';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useStoreState } from 'providers/StoreStateContext';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useGetCopyrightList } from 'services/account';
import { useGetGenres, useGetLanguages } from 'services/enums';
import { ITrackMutationForm, TRACK_CENSORIOUS } from 'services/tracks/types';
import { GENRE, STATUS } from 'services/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';
import { useEnumToSelectOptions } from 'utils/components/inputs/select';

const TrackData = () => {
  const { t } = useTranslation();
  const { getSelectOptions } = useEnumToSelectOptions();

  const languages = useGetLanguages();

  const copyrightOptions = useGetCopyrightList();

  const genres = useGetGenres();

  const {
    values,
    setFieldValue,
    status,
    submitCount,
    errors,
    initialValues,
  }: IFormikContextType<ITrackMutationForm> = useFormikContext<ITrackMutationForm>();
  console.log('status i track data', status?.displayMode);
  const boolOptions = [
    { value: true, label: t(`enum.LABEL_REPAYMENTS.Yes`) },
    { value: false, label: t(`enum.LABEL_REPAYMENTS.No`) },
  ];

  const navigate = useNavigate();

  const { setForm } = useStoreState();

  const onGoToStep = (step: string) => {
    setForm('trackForm', values);
    navigate(`/track/${values.id ? `edit/${values.id}` : 'create'}/${step}`);
  };

  const showAssignIsrcSelect = !status?.displayMode;
  const showIsrcInput = !values.assignIsrc || status?.displayMode;

  return (
    <StepsTab
      // nextName={values.isInstrumental ? 'titles' : 'lyrics'}
      nextName={'artists'}
      onNext={() => onGoToStep('artists')}
      backName="file"
      onBack={() => onGoToStep('file')}
    >
      <DataWrapper>
        {/* {!!initialValues.mainTitle.title.length && (
        <HeaderStatusWrapper title={t('input.label.status')}>
          {initialValues.status && <LabeledStatus status={initialValues.status} fullWidth />}
        </HeaderStatusWrapper>
      )} */}
        <ViewHint hintId="track-data-title" />
        <FormInput.Text name="mainTitle.title" label={`${t('input.label.title')}`} />
        <FormInput.Text name="mainTitle.version" label={`${t('input.label.version')}`} />
        <LanguageSelectPopupForm
          onSelectLanguage={(language, actions) => {
            setFieldValue('mainTitle.language', language?.id ?? null);
            actions.close();
          }}
          initialLanguage={languages.data?.find((l) => l.id === values.mainTitle.language)}
          displayMode={status?.displayMode}
          trigger={
            <div className="flex w-full cursor-pointer">
              <Input.Text
                required
                name=""
                error={submitCount > 0 ? errors.mainTitle?.language : undefined}
                label={t('input.label.language')}
                value={languages.data?.find((l) => l.id === values.mainTitle.language)?.name ?? ''}
                style={{ pointerEvents: 'none' }}
              />
            </div>
          }
        />

        <div />
        <ViewHint hintId="track-characteristics" />

        <CensoriousSelectPopupForm
          onSelectCensorious={(censorious, actions) => {
            setFieldValue('censorious', censorious ?? null);
            actions.close();
          }}
          initialCensorious={values.censorious}
          displayMode={status?.displayMode}
          trigger={
            <div className="flex w-full cursor-pointer">
              <Input.Text
                required
                name=""
                error={submitCount > 0 ? errors.censorious : undefined}
                label={t('input.label.censorious')}
                value={
                  !!values.censorious && values.censorious !== -1
                    ? t(`censorious.${TRACK_CENSORIOUS[values.censorious]}.name`)
                    : ''
                }
                style={{ pointerEvents: 'none' }}
              />
            </div>
          }
        />

        <GenrePopupForm
          onSelectGenre={(genre, actions) => {
            setFieldValue('genre.id', genre ?? null);
            actions.close();
          }}
          initialGenre={values.genre.id}
          displayMode={status?.displayMode}
          trigger={
            <div className="flex w-full cursor-pointer">
              <Input.Text
                required
                name=""
                error={submitCount > 0 ? errors.genre?.id : undefined}
                label={t('input.label.genre')}
                value={
                  !!values.genre.id && values.genre.id !== -1
                    ? t(`genre.${GENRE[values.genre.id]}.name`)
                    : ''
                }
                style={{ pointerEvents: 'none' }}
              />
            </div>
          }
        />
        <CreatedWithAiSelectPopupForm
          onSelectCreatedWithAi={(isCreatedWithAi, actions) => {
            setFieldValue('isCreatedWithAi', isCreatedWithAi ?? null);
            actions.close();
          }}
          initialCreatedWithAi={values.isCreatedWithAi}
          displayMode={status?.displayMode}
          trigger={
            <div className="flex w-full cursor-pointer">
              <Input.Text
                required
                name=""
                error={submitCount > 0 ? errors.isCreatedWithAi : undefined}
                label={t('input.label.isCreatedWithAi')}
                value={
                  typeof values.isCreatedWithAi === 'boolean'
                    ? t(`created-with-ai.${String(values.isCreatedWithAi)}.name`)
                    : ''
                }
                style={{ pointerEvents: 'none' }}
              />
            </div>
          }
        />
        <InstrumentalSelectPopupForm
          onSelectInstrumental={(isInstrumental, actions) => {
            setFieldValue('isInstrumental', isInstrumental ?? null);
            actions.close();
          }}
          initialInstrumental={values.isInstrumental}
          displayMode={status?.displayMode}
          trigger={
            <div className="flex w-full cursor-pointer">
              <Input.Text
                required
                name=""
                error={submitCount > 0 ? errors.isInstrumental : undefined}
                label={t('input.label.instrumental')}
                value={
                  typeof values.isInstrumental === 'boolean'
                    ? t(`instrumental.${String(values.isInstrumental)}.name`)
                    : ''
                }
                style={{ pointerEvents: 'none' }}
              />
            </div>
          }
        />
        {!values.isInstrumental && (
          <>
            <div />
            <ViewHint hintId="track-lyrics" />
            <FormInput.Field
              className="h-[200px]"
              name="text"
              label={t('input.label.text')}
              disabled={values.isInstrumental}
            />
          </>
        )}
        <div />
        <ViewHint hintId="track-data-isrc" />

        {!status?.displayMode && (
          <div
            className="flex  w-full p-12 rounded-sm gap-4"
            style={{ backgroundColor: 'var(--background)' }}
          >
            <Button
              fullWidth
              variant={
                values.assignIsrc === false ? BUTTON_VARIANT.submit : BUTTON_VARIANT.background
              }
              onClick={() => setFieldValue('assignIsrc', false)}
            >
              <Button.Text text={t('input.option.yes')} />
            </Button>
            <Button
              fullWidth
              variant={
                values.assignIsrc === true ? BUTTON_VARIANT.submit : BUTTON_VARIANT.background
              }
              onClick={() => setFieldValue('assignIsrc', true)}
            >
              <Button.Text text={t('input.option.no')} />
            </Button>
          </div>
        )}
        <FormInput.Text
          required={!values.assignIsrc}
          name="isrc"
          label={t('input.label.isrc')}
          type="number"
          disabled={values.assignIsrc}
        />

        <div />
        <ViewHint hintId="music-product-digital-data-copyrights" />
        <div className="flex w-full gap-2">
          <YearSelectPopupForm
            onSelectYear={(genre, actions) => {
              setFieldValue('pline.year', genre ?? null);
              actions.close();
            }}
            initialYear={typeof values.pline?.year === 'number' ? values.pline?.year : null}
            displayMode={status?.displayMode}
            trigger={
              <div className="flex w-full max-w-40 cursor-pointer">
                <Input.Text
                  required
                  name=""
                  error={submitCount > 0 ? (errors.pline as any)?.year : undefined}
                  label={t('input.label.year')}
                  value={values.pline?.year ?? ''}
                  style={{ pointerEvents: 'none' }}
                />
              </div>
            }
          />
          <CopyrightPopupForm
            onSelectCopyright={(name, actions) => {
              setFieldValue('pline.name', name ?? null);
              actions.close();
            }}
            initialCopyright={values.pline?.name ?? null}
            displayMode={status?.displayMode}
            mode="pline"
            trigger={
              <div className="flex w-full cursor-pointer">
                <Input.Text
                  required
                  name=""
                  error={submitCount > 0 ? (errors.pline as any)?.name : undefined}
                  label={t('input.label.pline')}
                  value={values.pline?.name ?? ''}
                  style={{ pointerEvents: 'none' }}
                  titleEnabled
                />
              </div>
            }
          />
        </div>
        <div className="flex w-full gap-2">
          <YearSelectPopupForm
            onSelectYear={(genre, actions) => {
              setFieldValue('cline.year', genre ?? null);
              actions.close();
            }}
            initialYear={typeof values.cline?.year === 'number' ? values.cline?.year : null}
            displayMode={status?.displayMode}
            trigger={
              <div className="flex w-full max-w-40 cursor-pointer">
                <Input.Text
                  required
                  name=""
                  error={submitCount > 0 ? (errors.cline as any)?.year : undefined}
                  label={t('input.label.year')}
                  value={values.cline?.year ?? ''}
                  style={{ pointerEvents: 'none' }}
                />
              </div>
            }
          />
          <CopyrightPopupForm
            onSelectCopyright={(name, actions) => {
              setFieldValue('cline.name', name ?? null);
              actions.close();
            }}
            initialCopyright={values.cline?.name ?? null}
            displayMode={status?.displayMode}
            mode="cline"
            trigger={
              <div className="flex w-full cursor-pointer">
                <Input.Text
                  required
                  name=""
                  error={submitCount > 0 ? (errors.cline as any)?.name : undefined}
                  label={t('input.label.cline')}
                  value={values.cline?.name ?? ''}
                  style={{ pointerEvents: 'none' }}
                  titleEnabled
                />
              </div>
            }
          />
        </div>
        <div />
        {!!status?.displayMode && <ViewHint hintId={STATUS[values.status]} />}
      </DataWrapper>
    </StepsTab>
  );
};

export default TrackData;
